export default __webpack_public_path__ + "static/media/smallColoredLogoSimer.c4457590.svg";